import React from "react";

//We Use react-icons/all-files here to ensure that only the icons we use are included in the bundle
// This saves about ~1.5 mb in bundle size as well as increasing the realiablity of the
// as assets precompile process
// Material Design icons
// Font Awesome Iconns
import { FaArrowsAltH } from "@react-icons/all-files/fa/FaArrowsAltH";
import { FaArrowsAltV } from "@react-icons/all-files/fa/FaArrowsAltV";
import { FaBan } from "@react-icons/all-files/fa/FaBan";
import { FaCcStripe } from "@react-icons/all-files/fa/FaCcStripe";
import { FaCheckCircle } from "@react-icons/all-files/fa/FaCheckCircle";
import { FaCog } from "@react-icons/all-files/fa/FaCog";
import { FaCreditCard } from "@react-icons/all-files/fa/FaCreditCard";
import { FaEye } from "@react-icons/all-files/fa/FaEye";
import { FaFacebookF } from "@react-icons/all-files/fa/FaFacebookF";
import { FaFileInvoiceDollar } from "@react-icons/all-files/fa/FaFileInvoiceDollar";
import { FaGoogle } from "@react-icons/all-files/fa/FaGoogle";
import { FaHandHoldingUsd } from "@react-icons/all-files/fa/FaHandHoldingUsd";
import { FaInfoCircle } from "@react-icons/all-files/fa/FaInfoCircle";
import { FaInstagram } from "@react-icons/all-files/fa/FaInstagram";
import { FaMobileAlt } from "@react-icons/all-files/fa/FaMobileAlt";
import { FaMoneyBill } from "@react-icons/all-files/fa/FaMoneyBill";
import { FaPercent } from "@react-icons/all-files/fa/FaPercent";
import { FaPlusCircle } from "@react-icons/all-files/fa/FaPlusCircle";
import { FaPrint } from "@react-icons/all-files/fa/FaPrint";
import { FaRegCalendar } from "@react-icons/all-files/fa/FaRegCalendar";
import { FaSmile } from "@react-icons/all-files/fa/FaSmile";
import { FaSpinner } from "@react-icons/all-files/fa/FaSpinner";
import { FaTrash } from "@react-icons/all-files/fa/FaTrash";
import { FaTwitter } from "@react-icons/all-files/fa/FaTwitter";
import { MdAdd } from "@react-icons/all-files/md/MdAdd";
import { MdBrush } from "@react-icons/all-files/md/MdBrush";
import { MdCheck } from "@react-icons/all-files/md/MdCheck";
import { MdChevronLeft } from "@react-icons/all-files/md/MdChevronLeft";
import { MdChevronRight } from "@react-icons/all-files/md/MdChevronRight";
import { MdClose } from "@react-icons/all-files/md/MdClose";
import { MdCloudDownload } from "@react-icons/all-files/md/MdCloudDownload";
import { MdCloudUpload } from "@react-icons/all-files/md/MdCloudUpload";
import { MdContentCopy } from "@react-icons/all-files/md/MdContentCopy";
import { MdDelete } from "@react-icons/all-files/md/MdDelete";
import { MdDone } from "@react-icons/all-files/md/MdDone";
import { MdDragHandle } from "@react-icons/all-files/md/MdDragHandle";
import { MdEdit } from "@react-icons/all-files/md/MdEdit";
import { MdError } from "@react-icons/all-files/md/MdError";
import { MdExpandLess } from "@react-icons/all-files/md/MdExpandLess";
import { MdExpandMore } from "@react-icons/all-files/md/MdExpandMore";
import { MdHelp } from "@react-icons/all-files/md/MdHelp";
import { MdLastPage } from "@react-icons/all-files/md/MdLastPage";
import { MdMenu } from "@react-icons/all-files/md/MdMenu";
import { MdPets as MissingIcon } from "@react-icons/all-files/md/MdPets";
import { MdRefresh } from "@react-icons/all-files/md/MdRefresh";
import { MdRemove } from "@react-icons/all-files/md/MdRemove";
import { MdSearch } from "@react-icons/all-files/md/MdSearch";
import { MdWeb } from "@react-icons/all-files/md/MdWeb";
// Remix Icons
import { RiExternalLinkLine } from "@react-icons/all-files/ri/RiExternalLinkLine";
import { RiMailSendLine } from "@react-icons/all-files/ri/RiMailSendLine";
import { RiPhoneLine } from "@react-icons/all-files/ri/RiPhoneLine";
import { MdDragIndicator } from "react-icons/md";
import { MdArrowOutward } from "react-icons/md";
import { useSpring, animated } from "react-spring";

import theme, { ColorName, FontSize } from "../Design/theme";
import PosbossCloud from "./PosbossCloud";
import soguiLogoPink from "./SoguiLogoPink";

const { colorMap, fontSize } = theme;
export type PaymentTypeIcon =
  | "cash"
  | "card"
  | "account"
  | "hospo"
  | "wastage"
  | "discount"
  | "pbCloud";
export const iconMap = {
  delete: MdDelete,
  search: MdSearch,
  brush: MdBrush,
  chevronLeft: MdChevronLeft,
  chevronRight: MdChevronRight,
  dragHandle: MdDragHandle,
  dragIndicator: MdDragIndicator,
  cloudDownload: MdCloudDownload,
  cloudUpload: MdCloudUpload,
  close: MdClose,
  checkCircle: FaCheckCircle,
  loading: FaSpinner,
  upArrow: MdArrowOutward,
  error: MdError,
  calendarToday: FaRegCalendar,
  edit: MdEdit,
  menu: MdMenu,
  refresh: MdRefresh,
  done: MdDone,
  check: MdCheck,
  help: MdHelp,
  add: MdAdd,
  cash: FaMoneyBill,
  card: FaCreditCard,
  credit: FaCreditCard,
  creditCardSurcharge: FaCreditCard,
  gratuity: FaHandHoldingUsd,
  account: FaFileInvoiceDollar,
  regulr: FaMobileAlt,
  hospo: FaSmile,
  wastage: FaTrash,
  discount: FaPercent,
  invoice: FaFileInvoiceDollar,
  remove: MdRemove,
  printer: FaPrint,
  leftRight: FaArrowsAltH,
  upDown: FaArrowsAltV,
  readOnly: FaEye,
  disabled: FaBan,
  stripe: FaCcStripe,
  stripeInvoice: FaCcStripe,
  plusCircle: FaPlusCircle,
  cog: FaCog,
  copy: MdContentCopy,
  forward: MdLastPage,
  mail: RiMailSendLine,
  phone: RiPhoneLine,
  externalLink: RiExternalLinkLine,
  info: FaInfoCircle,
  pbCloud: PosbossCloud,
  sogui: soguiLogoPink,
  twitter: FaTwitter,
  instagram: FaInstagram,
  google: FaGoogle,
  facebook: FaFacebookF,
  website: MdWeb,

  // If you are using these two do expansion of rows
  // maybe think about using <DropDownIcon  /> instead
  expandMore: MdExpandMore,
  expandLess: MdExpandLess,
} as const;
export type IconName = keyof typeof iconMap;
export interface IconProps {
  icon: IconName;
  // current is a special svg value that will use the current text Color css property
  color?: ColorName | "current";
  size?: FontSize | `${number}px` | `${number}` | number;
  className?: string;
}
const Icon = ({ icon, color, size, className }: IconProps) => {
  const IconComponent = iconMap[icon];
  if (!IconComponent) {
    console.warn(`Its looks the ${icon} is not currently included`);
    if (process.env.NODE_ENV !== "production") {
      return <MissingIcon color={colorMap["pink-400"]} size={size} />;
    } else {
      return null;
    }
  }

  return (
    <IconComponent
      className={className || "inline-block align-middle"}
      color={getColor(color) || colorMap["primary-100"]}
      size={getFontSize(size) || fontSize["2xl"]}
    />
  );
};
const getColor = (color?: ColorName | "current") => {
  if (!color) return undefined;

  if (colorMap.hasOwnProperty(color)) {
    return colorMap[color];
  } else return color;
};
const getFontSize = (size?: string | number) => {
  if (!size) return undefined;

  if (fontSize.hasOwnProperty(size)) {
    return fontSize[size as FontSize];
  } else return size.toString();
};
export const DropDownIcon = ({
  isExpanded,
  rotateBy,
  ...props
}: Partial<IconProps> & {
  isExpanded: boolean;
  rotateBy?: number;
}) => {
  const styles = useSpring({
    transform: `rotateZ(${isExpanded ? rotateBy || -90 : 0}deg)`,
  });
  return (
    <animated.span className="inline-block" style={styles}>
      <Icon icon="expandMore" {...props} />
    </animated.span>
  );
};

// This is used in development as a quick way to see all the icons
// Don't commit whereever this is used
const getKeys = Object.keys as <T extends object>(obj: T) => Array<keyof T>;
export const AllIcons = () => {
  if (process.env.NODE_ENV !== "development") return null;
  return (
    <div className="flex flex-wrap">
      {getKeys(iconMap).map((icon) => (
        <div className="flex w-1/6 flex-col items-center">
          <Icon icon={icon} size="2xl" />
          <span className="text-sm">{icon}</span>
        </div>
      ))}
    </div>
  );
};
export default Icon;
